<template>
  <div class="resource_body">
    <div>
      <el-row style="margin: 0px">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
          <div class="grid-content bg-purple"></div>
          <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
              <div class="grid-content bg-purple"></div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 210px;
                    background-color: white;
                    height: 80px;
                    border-radius: 15px;
                    padding-top: 10px;
                  "
                >
                  <el-menu
                    :default-active="activeIndex"
                    class="el-menu-vertical-demo"
                    @select="handleOpen"
                  >
                    <el-menu-item index="1">
                      <i class="el-icon-s-platform"></i>
                      <span slot="title">教学资源</span>
                    </el-menu-item>
                    <el-menu-item index="2">
                      <i class="el-icon-s-order"></i>
                      <span slot="title">课程评价</span>
                    </el-menu-item>
                    <el-menu-item index="3">
                      <i class="el-icon-info"></i>
                      <span slot="title">等保与软著</span>
                    </el-menu-item>
                  </el-menu>
                </div>
              </div>
            </el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
              <div class="grid-content bg-purple-light"></div>
              <div style="display: flex; align-items: center">
                <div class="content_text_body">
                  <div v-if="this.activeIndex === '1'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        教学资源
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div style="width: 900px"></div>
                      <div class="resource_right">
                        <div
                          class="pdf_item_box"
                          v-for="(item, index) in resourceData.jiaoxue"
                          :key="index"
                          @click="openPdf(item.path)"
                        >
                          <img
                            class="pdf_icon"
                            src="../../assets/icons/pdf.png"
                          />
                          <span class="pdf_name">{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '2'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        课程评价
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div style="width: 900px"></div>
                      <div class="resource_right">
                        <div
                          class="pdf_item_box"
                          v-for="(item, index) in resourceData.kecheng"
                          :key="index"
                          @click="openPdf(item.path)"
                        >
                          <img
                            class="pdf_icon"
                            src="../../assets/icons/pdf.png"
                          />
                          <span class="pdf_name">{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '3'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        等保与软著
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div style="width: 900px"></div>
                      <div class="resource_right">
                        <div
                          class="pdf_item_box"
                          v-for="(item, index) in resourceData.dengbao"
                          :key="index"
                          @click="openPdf(item.path)"
                        >
                          <img
                            class="pdf_icon"
                            src="../../assets/icons/pdf.png"
                          />
                          <span class="pdf_name">{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Resource",
  data () {
    return {
      activeIndex: "1",
      buttonType1: "",
      buttonType2: "",
      buttonType3: "",
      buttonType4: "",
      buttonIndex: "",
      resourceData: {
        jiaoxue: [{
          name: '课程课件.pdf',
          path: process.env.BASE_URL + 'pdf/教学资源/课程课件.pdf'
        }, {
          name: '课程教案.pdf',
          path: process.env.BASE_URL + 'pdf/教学资源/课程教案.pdf'
        }, {
          name: '实验指导书.pdf',
          path: process.env.BASE_URL + 'pdf/教学资源/实验指导书.pdf'
        }, {
          name: '课程教学指导书.pdf',
          path: process.env.BASE_URL + 'pdf/教学资源/课程教学指导书.pdf'
        },],
        kecheng: [{
          name: '课程团队成员和课程内容政治审查意见.pdf',
          path: process.env.BASE_URL + 'pdf/课程评价/课程团队成员和课程内容政治审查意见.pdf'
        }, {
          name: '课程内容学术性评价意见.pdf',
          path: process.env.BASE_URL + 'pdf/课程评价/课程内容学术性评价意见.pdf'
        }, {
          name: '校外评价意见.pdf',
          path: process.env.BASE_URL + 'pdf/课程评价/校外评价意见.pdf'
        }],
        dengbao: [{
          name: '等级保护备案证明.pdf',
          path: process.env.BASE_URL + 'pdf/等级保护与知识产权/等级保护备案证明.pdf'
        }, {
          name: '等级保护测评报告.pdf',
          path: process.env.BASE_URL + 'pdf/等级保护与知识产权/等级保护测评报告.pdf'
        }, {
          name: '聚乙烯合成3D虚拟仿真实验软件著作权.pdf',
          path: process.env.BASE_URL + 'pdf/等级保护与知识产权/聚乙烯合成3D虚拟仿真实验软件著作权.pdf'
        }]
      }
    };
  },
  mounted () {
    this.cutpage("1");
    let num = localStorage.getItem("redirectNum");
    if (num !== "undefined") {
      this.activeIndex = num;
    } else {
      this.activeIndex = "1";
    }
  },
  methods: {
    cutpage (index) {
      this.buttonIndex = index;
      this.getbottontype();
    },
    getbottontype () {
      if (this.buttonIndex === "1") {
        this.buttonType1 = "primary";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "2") {
        this.buttonType1 = "";
        this.buttonType2 = "primary";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "3") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "primary";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "4") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "primary";
      }
    },
    openPdf (url) {
      window.open(process.env.BASE_URL + "pdfjs/web/viewer.html?file=" + window.location.protocol + "//" + window.location.host + url);
    },
    handleOpen (key, keyPath) {
      this.activeIndex = key;
    },
  },
};
</script>

<style scoped>
.resource_body {
  background: url('../../assets/banner/login.png');
}

.content_text_body {
  display: flex;
  background-color: white;
  height: auto;
  min-height: 625px;
  margin-bottom: 40px;
  border-radius: 15px;
  flex-direction: column;
  width: 100%;
}

.content_text_m {
}

.resource_right {
  width: 100%;
  font-weight: 400;
  padding: 0 20px;
}

.pdf_item_box {
  height: 50px;
  border: 1px solid #ececec;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 10px;
  cursor: pointer;
}
.pdf_icon {
  width: 30px;
  height: 30px;
}

.pdf_name {
  margin-left: 10px;
  color: #525252;
}

.knowledge_text {
  text-indent: 2em;
  font-size: 18px;
  margin: 5px 20px 0 20px;
  text-align: left;
  line-height: 30px;
  font-weight: 300;
  line-height: 40px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>